export const VALID_PATTERN = /\S+@\S+\.[a-zA-Z]{2,4}$/;
export const NON_SSO = "NON_SSO";
export const SSO = "SSO";
export const LOGOUT_ERROR = "User not logged in";